import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { RelatorioService } from "./../services/relatorio/relatorio.service";

@Component({
    selector: 'app-acompanhamento-diario-de-mapeamentos',
    templateUrl: './acompanhamento-diario-de-mapeamentos.component.html',
    styleUrls: ['./acompanhamento-diario-de-mapeamentos.component.scss']
})
export class AcompanhamentoDiarioDeMapeamentosComponent implements OnInit {

    public loading = true;
    public loadingModal = true;

    public dataSelected:any = null;

    public listaMapeamentos:Array<any> = [];
    public listaMapeamentosAtualizacao:Array<any> = [];
    public listaMunicipios:Array<any> = [];

    public curr = new Date();
    public first = this.curr.getDate() - this.curr.getDay();
    public last = this.first + 6;

    public firstday = new Date(this.curr.setDate(this.first)).toUTCString();
    public lastday = new Date(this.curr.setDate(this.last)).toUTCString();

    public stringMapeamentos = '';

    public filter: FormGroup = this.fb.group({
        data_inicio: new FormControl(this._convert(this.firstday), []),
        data_fim: new FormControl(this._convert(this.lastday), []),
    });

    constructor(
        private _notify: SnotifyService,
        private relatorioService: RelatorioService,
        private fb: FormBuilder
    ) {

    }

    ngOnInit() {
        this.loadData();
    }

    public loadData() {
        this.loading = true;
        this. loadMapeamentsoDiarios();
    }

    public loadMapeamentsoDiarios() {
        this.relatorioService.totalMapeamentosDiarios(this.getFilters()).subscribe(
            ({data}:any) => {
                this.loading = false
                this.listaMapeamentos = data;
            },
            error => {
                this.loading = false
                this._notify.error("Ocorreu um erro ao carregar os dados")
            }
        )
    }

    public loadListaMunicipiosDia(dataSelected: any) {
        this.loadingModal = true;
        this.listaMunicipios = [];
        this.dataSelected = dataSelected;

        this.stringMapeamentos = 'Mapeados';
        this.relatorioService.totalMapeamentosDiariosListaMunicipios({ data: dataSelected}).subscribe(
            ({data}:any) => {
                this.loadingModal = false;
                this.listaMunicipios = data;
            },
            error => {
                this.loadingModal = false;
                this._notify.error("Ocorreu um erro ao carregar a lista de municipios")
            }
        )
    }

    public getFilters() {
        const filter = {};

        Object.keys(this.filter.controls).forEach((_filter) => {
            filter[_filter] = this.filter.controls[_filter].value;
        });

        return filter;
    }

    public toFilter() {
        this.reset(false);
        this.loadData();
    }

    public reset(reload: boolean): void {
        this.listaMapeamentos = []
        this.listaMapeamentosAtualizacao = []

        if(reload) {
            Object.keys(this.filter.controls).forEach(key => {
                this.filter.controls[key].setValue(null);
            });

            this.loadData();
        }
    }

    private _convert(str) {
        let date = new Date(str), mnth = ("0" + (date.getMonth() + 1)).slice(-2), day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }
}
